import { BaseConfig } from '../ServiceConfig';

export interface IrisConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.IrisServiceConfigData';
  url: string;
}

export const IrisConfigurationFields: (keyof IrisConfiguration)[] = ['url'];

export const BlankIrisConfiguration: IrisConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.IrisServiceConfigData',
} as IrisConfiguration;
